<template>
  <div style="height: 100%">
    <app-base-main noPadding>
      <template #filter-group>
        <app-filter-group
                @query="$gjNoticeQuery"
                @reset="$gjReset"
        >
          <gj-select-input
              :options="[
                {id: 0, text: '用户名'},
                {id: 1, text: '真实姓名'},
              ]"
              v-model="searchKeyword"
          >
          </gj-select-input>
        </app-filter-group>
      </template>
      <template #operate-group>
        <gj-button
            type="primary"
            @click="clickAddUser"
            v-if="$permission('role:addUser')"
        >
          添加用户
        </gj-button>
        <gj-button
            @click="removeUser(null)"
            v-if="$permission('role:delUser')"
        >
          批量移除
        </gj-button>
      </template>
      <template #table>
        <gj-table
            :columns="columns"
            adaptParent
            ref="gjTable"
            :data="tableData"
            selection
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
            :pagination="pagination"
            :loading="loading"
            :selectable="eqSelectable()"
        >
          <template v-slot:op="{ row }">
            <gj-button-group type="dropdown-op" v-if="row.accountType.code !== 'MAIN' && $permission('role:delUser')">
              <gj-button type="text" @click="removeUser(row)">移除</gj-button>
            </gj-button-group>
          </template>
        </gj-table>
      </template>
    </app-base-main>
    <!--<gj-modal
        :visible.sync="modalVisible.removeFlag"
        type="info"
        size="normal"
        @cancel="modalVisible.removeFlag = false"
        @confirm="modalVisible.removeFlag = false"
    >
      <template #header>
        <span>提示</span>
      </template>
      <template #content>
        <div style="padding: 10px;">
          <gj-text-alert type="warning">
            确定要移除用户`{{modalItem.removeRow.name}}`吗?
          </gj-text-alert>
        </div>
      </template>
    </gj-modal>-->
    <gj-modal
        :visible.sync="modalVisible.addUserFlag"
        notFooterPadding
        @cancel="addCancel"
        @confirm="addConfirm"
        size="800_auto"
    >
      <template #header>
        <span>添加用户</span>
      </template>
      <template #content>
        <div>
          <el-transfer
              style="text-align: left;justify-content: center;"
              v-model="checkUserList"
              filterable
              :titles="['未选用户', '已选用户']"
              :format="{
                  noChecked: '${total}',
                  hasChecked: '${checked}/${total}'
              }"
              :data="userList">
          </el-transfer>
        </div>
      </template>
    </gj-modal>
    <!--<gj-modal
        :visible.sync="modalVisible.batchRemoveFlag"
        type="info"
        size="normal"
        @cancel="modalVisible.batchRemoveFlag = false"
        @confirm="modalVisible.batchRemoveFlag = false"
    >
      <template #header>
        <span>提示</span>
      </template>
      <template #content>
        <div style="padding: 10px;">
          <gj-text-alert type="warning">
            确定要批量移除选中用户吗?
          </gj-text-alert>
        </div>
      </template>
    </gj-modal>-->
  </div>
</template>

<script>
  import {userPage,delUserRole,findAll,queryRoleUser,configUserRole} from '../../../../../api/setting';
  import {queryMixin, selectionMixin} from "../../../../../minxins";
  import {USER_GET_USER_OPTIONS} from "../../../../../store/action-types";

    export default {
      name: "app-role-user",
      mixins: [queryMixin,selectionMixin],
      created(){
        //查询出所有用户
        findAll().then(response => {
           this.userList = this.transitionObj(response.data)
        })
      },
      data() {
        return {
          searchKeyword: {
            key:0,
            value: null
          },
          columns: [
            {
              id: 'userName',
              header: '用户名',
              fixed: 'left',
              field: 'userName',
              minWidth: '120px',
              notCustomColumn: true
            },
            {
              id: 'name',
              header: '真实姓名',
              fixed: 'left',
              field: 'name',
              minWidth: '120px',
              notCustomColumn: true
            },
            {
              id: 'phone',
              header: '手机号码',
              fixed: 'left',
              field: 'phone',
              minWidth: '120px',
              notCustomColumn: true
            },
            {id: 'email', header: '邮箱', field: 'email', minWidth: '120px', default: true},
            {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true}
          ],
          tableData: [],
          modalVisible: {
            removeFlag: false,
            addUserFlag: false,
            batchRemoveFlag: false,
          },
          modalItem: {
              removeRow: null,
          },
          userList: [],
          checkUserList: [],
        }
      },
      props: ['roleId'],
      watch:{
        roleId: {
          deep: true,  // 深度监听
          handler(newVal,oldVal) {
            this.$emit('query')
          }
        }
      },
      methods: {
        $gjReset() {
          this.searchKeyword = {
            key:0,
            value: null
          };
          this.$gjResetPage();
        },
        removeUser(row) {
          if(row == null && this.selectedRows.length ==0){
            return this.$message.error("请先勾选需要移除的角色用户")
          }
          const vm = this;
          const modal = this.$gjCreate("gj-info-modal", {
            props: {
              title:'移除确认',
              content: `是否确认移除当前用户？`,
            },
            on: {
              cancel: () => modal.$gjDestroy(),
              confirm() {
                modal.confirmLoading = true;
                const params = {
                  roleId: vm.roleId,
                  userIdList: []
                }
                if(row != null){
                  params.userIdList.push(row.id)
                }else{
                  for (var i=0;i<vm.selectedRows.length;i++){
                    params.userIdList.push(vm.selectedRows[i].id)
                  }
                }
                delUserRole(params).then(response => {
                  if(response.isSuccess){
                      vm.$message.success("操作成功")
                      modal.$gjDestroy();
                      vm.$emit('query');
                  }else{
                      vm.$message.error(response.msg)
                  }
                }).complete(() =>{
                    modal.confirmLoading = false;
                })
              }
            },
          });
        },
        batchRemove() {
          this.modalVisible.batchRemoveFlag = true;
        },
        clickAddUser() {
          queryRoleUser(this.roleId).then(response => {
            this.checkUserList = response.data
            this.modalVisible.addUserFlag = true;
          }).complete(() => {
             this.loading = false;
          })
        },
        addConfirm() {
          this.loading = true;
          const params = {
            roleId: this.roleId,
            userIdList: this.checkUserList
          };
          configUserRole(params).then(response => {
            if(response.isSuccess){
              this.$emit('query');
              this.$message.success("操作成功");
              // 创建用户成功后，刷新整个应用的用户下拉信息
              this.$store.dispatch(USER_GET_USER_OPTIONS);
            }else{
              this.$message.error("操作失败："+response.msg);
            }
          }).complete(() => {
            this.loading = false;
          });
          this.modalVisible.addUserFlag = false;
        },
        addCancel() {
            this.modalVisible.addUserFlag = false;
        },
        $gjQuery() {
          // 分页查询
          this.loading = true;
          const params = {
            model: {
              roleId: this.roleId,
              userName: this.searchKeyword.key === 0?this.searchKeyword.value:null,
              name: this.searchKeyword.key === 1?this.searchKeyword.value:null
            },
            ...this.queryPagination,
            ...this.querySort
          };
          userPage(params).then(response => {
            this.tableData = response.data.records;
            this.pagination = this.getPagination(response.data);
          }).complete(() => {
            this.loading = false;
          })
        },
        transitionObj(data){
          const list = [];
          if(data === null || data.length == 0){
            return list;
          }
          for (var i=0;i<data.length;i++){
            list.push({
              key: data[i].id,
              label: data[i].name,
            })
          }
          return list;
        },
        eqSelectable() {
          return (row) => row.accountType.code !== 'MAIN';
        }
      }

    }
</script>

<style lang="scss" scoped>
  /deep/ .el-transfer-panel {
    /*border: 1px solid #EBEEF5;*/
    border-radius: 2px;
    /*overflow: hidden;*/
    background: #FFFFFF;
    display: inline-block;
    vertical-align: middle;
    width: 200px;
    max-height: 100%;
    box-sizing: border-box;
    height: 600px;
    position: relative;
  }
  /deep/ .el-transfer-panel__list.is-filterable {
    height: 523px!important;
    padding-top: 0;
  }
  .base-main /deep/ .table-shadow{
    box-shadow: unset;
  }
  ///deep/ .el-input__prefix{
  //  box-sizing: border-box;
  //  top: 1px;
  //  right: 1px;
  //  height: calc(100% - 2px);
  //  background: #EEEFF0;
  //  border: 1px solid #EBEEF5;
  //  border-left: none;
  //  cursor: pointer;
  //}
  /deep/ .el-button{
      border-radius: 2px;
      .el-icon-arrow-left:before{
          content: "\e6dd";
      }
      .el-icon-arrow-right:before {
          content: "\e6dc";
      }
  }
  /deep/ .base-main_margin{
    height: auto !important;
  }
  /deep/ .table{
    flex: 1;
    overflow: auto;
  }
</style>
